<template>
  <div class="zjhuaguo">
    <template v-if="!showOverview && !detailItem">
    <div class="section-1">
      <div class="video-wrap">
        <video v-if="siteConfig.homepage_video" :src="siteConfig.homepage_video" class="video-player" controls></video>
        <div v-else class="video-placeholder">
          <span class="play-icon">▶</span>
        </div>
      </div>
      <div class="intro-wrap">
        <div class="section-header">
          <div class="section-title">景区概况</div>
        </div>
          <div class="intro-content">
            <span v-html="overviewContent"></span>
            <span v-if="overviewContent" class="more-link" @click="onShowOverview">...更多>></span>
          </div>
      </div>
    </div>
    <div class="section-2">
      <div class="title-wrap">
        <div class="section-title">景区文化</div>
      </div>
      <div class="culture-grid">
        <div v-for="(item, index) in cultureList" :key="index" class="culture-item" @click="openArticle('景区文化', item)">
          <img :src="item.img" alt="" class="culture-img">
          <div class="culture-label" :style="{backgroundImage: 'url(' + item.bgImg + ')'}">{{ item.title }}</div>
        </div>
      </div>
    </div>
      <SceneSection @select-scene="openArticle('景区风光', $event)" />
    </template>
    <ScenicOverview v-else-if="showOverview" @back="onBackFromOverview" @go-home="$emit('go-home')" />
    <ArticleDetail v-else :article="detailItem" :breadcrumb="detailBreadcrumb" :next-title="nextTitle" hide-date @go-home="$emit('go-home')" @breadcrumb-click="onBreadcrumbClick" @next-article="goNextArticle" />
  </div>
</template>

<script>
import { getArticles, getArticleDetail, getConfig, getPrevNext } from '../api/index'
import cultureImg from '../assets/imgs/4834c0ae-e705-4aa4-8a18-9fc191e261ff.png'
import bg1 from '../assets/imgs/11.png'
import bg2 from '../assets/imgs/12.png'
import bg3 from '../assets/imgs/13.png'
import bg4 from '../assets/imgs/14.png'
import bg5 from '../assets/imgs/15.png'
import bg6 from '../assets/imgs/16.png'
import bg7 from '../assets/imgs/17.png'
import bg8 from '../assets/imgs/18.png'
import SceneSection from './SceneSection.vue'
import ScenicOverview from './ScenicOverview.vue'
import ArticleDetail from './ArticleDetail.vue'

export default {
  name: 'ZouJinHuaguo',
  props: {
    defaultArticle: { type: Object, default: null },
    defaultSection: { type: String, default: '' },
  },
  emits: ['go-home'],
  components: {
    SceneSection,
    ScenicOverview,
    ArticleDetail,
  },
  data() {
    return {
      showOverview: false,
      detailItem: null,
      detailSection: '',
      overviewContent: '',
      siteConfig: {},
      cultureList: [],
    }
  },
  computed: {
    detailBreadcrumb() {
      if (this.detailSection) {
        return ['走进花果山', this.detailSection]
      }
      return []
    },
    nextTitle() {
      return (this.detailItem && this.detailItem.nextArticle) ? this.detailItem.nextArticle.title : ''
    },
  },
  watch: {
    showOverview(val) { if (val) this.$nextTick(() => { window.scrollTo(0, 0) }) },
    detailItem(val) { if (val) this.$nextTick(() => { window.scrollTo(0, 0) }) },
    defaultArticle: {
      handler(val) {
        if (val && this.detailItem && this.detailItem.id === val.id) return
        if (val) this.openArticle(this.defaultSection || '', val)
        else { this.detailItem = null; this.showOverview = false }
      },
      immediate: false
    },
    '$route.query.zjOverview': {
      handler(val) {
        this.showOverview = !!val && !this.detailItem
      },
      immediate: true
    },
    '$route.query.zjArticle': {
      handler(val) {
        if (!val) {
          this.detailItem = null
          this.showOverview = false
        }
      },
    },
  },
  mounted() {
    if (this.defaultArticle) {
      this.openArticle(this.defaultSection, this.defaultArticle)
    } else if (this.$route.query.zjOverview) {
      this.showOverview = true
    }
    this.fetchCultureData()
    this.fetchOverview()
    this.fetchConfig()
  },
  methods: {
    async fetchConfig() {
      try {
        const res = await getConfig()
        if (res.code === 200 && res.data) {
          this.siteConfig = res.data
        }
      } catch (e) {
        console.error('获取配置失败:', e)
      }
    },
    async fetchGallery() {
      try {
        const res = await getGallery('zh')
        if (res.code === 200 && res.data) {
          this.sceneList = res.data.map(item => ({
            id: item.id,
            title: item.title,
            img: item.thumbnailUrl || item.imageUrl,
            articleId: item.articleId,
            articleTitle: item.articleTitle,
            gridRowStart: item.gridRowStart,
            gridRowSpan: item.gridRowSpan,
            gridColumnStart: item.gridColumnStart,
            gridColumnSpan: item.gridColumnSpan,
          }))
        }
      } catch (e) {
        console.error('获取景区风光失败:', e)
      }
    },
    async fetchOverview() {
      try {
        const listRes = await getArticles({ category: 'overview', lang: 'zh', pageSize: 1 })
        const items = listRes.rows || listRes.data || []
        if (!items.length) return
        const detailRes = await getArticleDetail(items[0].id)
        if (detailRes.code === 200 && detailRes.data) {
          this.overviewContent = detailRes.data.summary || ''
        }
      } catch (e) {
        console.error('获取景区概况失败:', e)
      }
    },
    async fetchCultureData() {
      try {
        const res = await getArticles({ category: 'culture', lang: 'zh', pageNum: 1, pageSize: 8 })
        if (res.code !== 200) return
        const bgImgs = [bg1, bg2, bg3, bg4, bg5, bg6, bg7, bg8]
        this.cultureList = (res.rows || []).map((item, i) => ({
          id: item.id,
          img: item.coverImage || cultureImg,
          title: item.title,
          bgImg: bgImgs[i % bgImgs.length],
          date: (item.publishTime || '').substring(0, 10),
          desc: item.summary || '',
        }))
      } catch (e) {
        console.error('获取景区文化数据失败:', e)
      }
    },
    async openArticle(section, item) {
      if (this.detailItem && this.detailItem.id === item.id) return
      this.detailSection = section
      this.detailItem = { ...item }
      this.$router.push({ query: { ...this.$route.query, menu: 1, zjSection: section, zjArticle: item.id } }).catch(() => {})
      if (item.id) {
        try {
          const res = await getArticleDetail(item.id)
          if (res.code === 200 && res.data) {
            this.detailItem = { ...item, ...res.data }
            const pn = await getPrevNext(item.id, { category: res.data.category, lang: res.data.lang || 'zh' })
            if (pn.code === 200 && pn.data) {
              this.detailItem = { ...this.detailItem, nextArticle: pn.data.next }
            }
          }
        } catch (e) {
          console.error('获取文章详情失败:', e)
        }
      }
    },
    onShowOverview() {
      this.$router.replace({ query: { ...this.$route.query, zjOverview: '1' } }).catch(() => {})
    },
    onBackFromOverview() {
      const q = { ...this.$route.query }
      delete q.zjOverview
      this.$router.replace({ query: q }).catch(() => {})
    },
    onBreadcrumbClick() {
      const q = { ...this.$route.query }
      delete q.zjArticle
      delete q.zjSection
      this.$router.replace({ query: q }).catch(() => {})
    },
    goNextArticle() {
      const next = this.detailItem && this.detailItem.nextArticle
      if (next) {
        this.openArticle(this.detailSection, { id: next.id, title: next.title })
      }
    },
  },
}
</script>

<style scoped lang="less">
.zjhuaguo{
  margin-top: 0.2rem;
  .section-1{
    height: 3.77rem;
    display: flex;
    gap: 0.2rem;
    margin-top: 0.1rem;
    .video-wrap{
      flex: 1;
      .video-player{
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      .video-placeholder{
        width: 100%;
        height: 100%;
        background: #000;
        display: flex;
        align-items: center;
        justify-content: center;
        .play-icon{
          font-size: 0.6rem;
          color: #fff;
          cursor: pointer;
        }
      }
    }
    .intro-wrap{
      flex: 1;
      min-width: 0;
      .section-header{
        height: 0.6rem;
        background: rgba(0,0,0,.05);
        display: flex;
        align-items: center;
        .section-title{
          height: 0.6rem;
          width: 1.8rem;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 0.24rem;
          color: #fff;
          background: #369BF8;
        }
      }
      .intro-content{
        margin-top: 0.1rem;
        font-size: 0.2rem;
        color: #4F4E4E;
        line-height: 0.34rem;
        white-space: pre-wrap;
        p{ margin: 0 0 0.08rem; }
        .more-link{
          color: #369BF8;
          font-size: 0.18rem;
          cursor: pointer;
          user-select: none;
        }
      }
    }
  }
  .section-2{
    margin-top: 0.5rem;
    .title-wrap{
      border-bottom: 1px solid #e0e0e0;
      margin-bottom: 0.25rem;
      .section-title{
        display: inline-block;
        font-size: 0.27rem;
        color: #115DB2;
        border-bottom: 2px solid #115DB2;
        padding-bottom: 0.02rem;
        margin-bottom: -1px;
      }
    }
    .culture-grid{
      display: flex;
      flex-wrap: wrap;
      gap: 0.2rem;
      margin-top: 0.1rem;
      .culture-item{
        width: calc((100% - 0.6rem) / 4);
        cursor: pointer;
        .culture-img{
          width: 100%;
          height: 2.6rem;
          object-fit: cover;
          display: block;
        }
        .culture-label{
          height: 0.5rem;
          line-height: 0.5rem;
          text-align: center;
          font-size: 0.22rem;
          color: #fff;
          background-size: cover;
          background-position: center;
        }
      }
    }
  }
}
</style>
